import { render, staticRenderFns } from "./UsersWidget.vue?vue&type=template&id=315d093a&scoped=true"
import script from "./UsersWidget.vue?vue&type=script&lang=js"
export * from "./UsersWidget.vue?vue&type=script&lang=js"
import style0 from "./UsersWidget.vue?vue&type=style&index=0&id=315d093a&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315d093a",
  null
  
)

export default component.exports